import { render, staticRenderFns } from "./StudentGroupSelectbox.vue?vue&type=template&id=3ff85013"
import script from "./StudentGroupSelectbox.vue?vue&type=script&lang=js"
export * from "./StudentGroupSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports